import { BaseModel } from '../../_base/crud';

export class Meeting extends BaseModel {
  id: number;
  subject: string;
  body: string;
  from_time: string;
  to_time: string;
  with: any[];
  responsible: any[];
  files: any[];
  receivers: any[];
  is_completed: boolean;
  is_important: boolean;
  location: string;
  related_to_list: any[];
  data: any;
  tags: any;
  drug: any;
  call_organizer: any;
  sales_call_type: any;
  duration: any;
  drug_id: any;

  clear() {
    // Intentional no-op: Method will be implemented by subclasses
  }
}
